// extracted by mini-css-extract-plugin
export var actionButton = "_kf-0";
export var fileInput = "_kf-2";
export var paperclip = "_kf-1";